export const ADMIN_NAV_ITEMS = [
  { to: "/manafix", label: "Início" },
  { to: "/manafix/products", label: "Pedidos" },
  { to: "/manafix/users", label: "Usuários" },
  { to: "/manafix/status", label: "Fluxos Status" },
  { to: "/manafix/bot-ops", label: "Bot Ops" },
  { to: "/manafix/transactions", label: "Transações" },
  { to: "/manafix/gradable-models", label: "Modelos" },
  { to: "/manafix/serials", label: "Seriais" },
  { to: "/manafix/serials/tags", label: "Etiquetas" },
  { to: "/manafix/art-labels", label: "Artes" },
  { to: "/manafix/stores", label: "Lojas" },
  { to: "/manafix/feriados", label: "Feriados" },
  { to: "/manafix/coupons", label: "Cupons" },
  { to: "/manafix/logs", label: "Logs", masterOnly: true },
  { to: "/manafix/presentations", label: "Apresentações", masterOnly: true },
];

export const PARTNER_NAV_ITEMS = [
  { to: "/partner", label: "Início" },
  { to: "/partner/products", label: "Pedidos" },
  { to: "/partner/status", label: "Fluxos Status" },
];
